<template>
  <div class="project_wrapper">
    <NavBar />
    <div v-if="!isShow">
      <van-col span='24' style="font-size:18px;font-weight:bold;text-align:center;margin-top:46px">维修项目记录</van-col>
      <van-row type="flex" justify="center" class="projectList_list">
        <van-col :span="24">
          <van-list v-model:error="error" error-text="请求失败，点击重新加载" v-model:loading="loading" :finished="finished" @load="onLoad">
            <div class="card" v-for="item in list" :key="item">
              <van-row class="projectList_site">
                <van-col :span="24">{{item.reqName}}---{{item.state}}</van-col>
              </van-row>
              <van-row>
                <van-col span="14" class="content_left">
                  <van-col span="24">项目类型：{{item.projectType}}</van-col>
                  <van-col span="24">申请人：{{item.orgType=='1'?item.orgName:item.orgType=='2'?item.ownerCommitteeName:''}}</van-col>
                  <van-col span="24">申请时间：{{item.proreportDate}}</van-col>
                </van-col>
                <van-col span="9" class="content_right" offset="1">
                  <van-col span="24" style="color:blue;font-size:18px;font-weight:bold" class="projectList_money">{{item.state=='进行中'?item.budgSum:item.state=='已完成'?item.inputFinalSum:''}}</van-col>
                  <van-col span="24">{{item.state=='进行中'?'预算金额（元）':item.state=='已完成'?'决算金额（元）':''}}</van-col>
                </van-col>
              </van-row>
            </div>
          </van-list>
        </van-col>
      </van-row>
    </div>
    <div v-if="isShow" style='padding-top:50px'>
      <van-empty image="error" description="该小区暂无维修记录" />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        loading: false,
        finished: false,
        list: [],
        regionName: "",
        id:'',
        isShow:false,
        error: false,
      };
    },
    methods: {
      onLoad() {
        let data={
          regionId:this.id,
          pageNum:1,
          pageSize:100
        }
        this.$postQuery('/WeChat/getProjectReqListByRegionId',data)
        .then((response)=>{
          console.log(response)
          if(response.code==200){
            this.list = response.data.list
            if(this.list.length==0){
              this.isShow=true
            }
            this.loading = false;
            // 数据全部加载完成
            if (this.list.length >= response.data.list.length) {
              this.finished = true;
            }
          }
        })
        .catch(()=>{
          this.error = true;
        })
      },
      // houseTest() {
        
      // },
    },
    created() {
      this.id = this.$route.query.id
    },
  }
</script>
<style>
  .project_wrapper h3 {
    text-align: center;
    margin-top: 46px;
  }

  .projectList_list .card {
    padding: 5px 10px;
    font-size: 12px;
  }

  .projectList_list .van-col {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .projectList_money {
    font-size: 16px;
    font-weight: bold;
  }

  .projectList_site {
    font-size: 14px;
    font-weight: bold;
  }

  .projcet_name {
    width: calc(100% - 3rem - 10px);
  }

  .projcet_state {
    width: 3rem;
    margin-left: 6px;
  }

  .content_left {
    text-align: left;
  }

  .content_right {
    text-align: center;
  }
</style>